module.exports = __webpack_public_path__ + "img/icon_trash.19320af0.svg";